/**
 * 지금 게임 화면이 열려 있는가 — 안 읽은 쪽지 안내 창의 재노출 판정이 쓴다.
 *
 * WHY: 닫은 창을 간격마다 다시 띄우면 게임 위에 떠 베팅을 방해한다(2026-11-03 독립 검토).
 * 판정 경로는 게임이 열리는 길 전부다:
 *   - 게임 경로(/gameplay/:id, /casino-gameplay/:id — 화면 안 게임과 그 경로에서 연 새 창)
 *   - 화면 안 게임 덧창(components/common/GamePopup)
 *   - 게임 세션 표식(utils/sessionGuard — 게임사 로비·미니게임을 연 새 창까지 안다)
 *
 * 표식은 끝난 것이 확인돼야 풀린다(화면을 옮겨 창 감시가 멈춘 뒤 창을 닫으면 새로고침까지 남는다). 그동안은 다시 띄우지 않을 뿐이고,
 * 게임 실행은 서버 진입 확인이 그대로 막으므로 안 읽은 쪽지를 지나칠 수 없다.
 */
import { isGameSessionOpen } from './sessionGuard';

const GAME_PATH_PREFIXES = ['/gameplay/', '/casino-gameplay/'];
const GAME_POPUP_SELECTOR = '.game-popup-overlay';

export const isGameScreenOpen = () => isGameSessionOpen()
  || GAME_PATH_PREFIXES.some((prefix) => window.location.pathname.startsWith(prefix))
  || document.querySelector(GAME_POPUP_SELECTOR) !== null;
